import { LinksContentTypeEnum } from '@api/api';

export const shouldHandleArticlePage = (slug?: string | string[]): boolean => {
  return Boolean(Number(slug));
};

export const isArticle = (type: LinksContentTypeEnum): boolean => type === 'articles';
export const isCategory = (type: LinksContentTypeEnum): boolean => type === 'categories';
